import { useAdminSignIn } from "../../Hooks/useAdminSignIn";

export default function CreateAccountLink({
  className = "portal-btn portal-btn--primary",
  children = "Create account",
  redirectTo = "/dashboard",
}) {
  const { register, pending, pendingLabel, error } = useAdminSignIn({
    redirectTo,
    notifyError: true,
  });

  return (
    <span className="portal-sign-in">
      <button
        type="button"
        className={className}
        disabled={pending}
        onClick={() => register().catch(() => {})}
      >
        {pending ? pendingLabel : children}
      </button>
      {error ? (
        <span className="portal-sign-in-error" role="alert">
          {error}
        </span>
      ) : null}
    </span>
  );
}
